import { DeleteOutlined } from '@ant-design/icons';
import { SelectController } from '@organisms';
import { Button, Col, Collapse, Row } from 'antd';
import {
  FieldArrayWithId,
  useFormContext,
  useFormState,
} from 'react-hook-form';

import {
  SettingsConfigType,
  TenantFormData,
} from 'src/features/tenants/types/tenantForm.types';

import { useTenantContextList } from '../../../../hooks/useTenantContextList';
import { SettingsBody } from './SettingsBody';

export interface SettingsListProps {
  settingField: 'add' | 'edit';
  fields: FieldArrayWithId<
    TenantFormData,
    'settings.add' | 'settings.edit',
    '_id'
  >[];
  onDelete: (index: number, id?: number) => void;
}
export const SettingsList = ({
  settingField,
  fields,
  onDelete,
}: SettingsListProps) => {
  const name: 'settings.add' | 'settings.edit' = `settings.${settingField}`;
  const { control, watch, setValue } = useFormContext<TenantFormData>();

  const { contextList, isLoading: isLoadingContextList } =
    useTenantContextList();

  const { errors } = useFormState<TenantFormData>();

  const deletedFields = watch('settings.delete');

  return fields.map((field, index) => (
    <Collapse.Panel
      style={{
        display: `${
          field.id && deletedFields?.includes(field.id) ? 'none' : 'block'
        }`,
        marginBlock: 10,
        border: `1px solid ${
          !!errors.settings?.[settingField]?.[index] ? '#700000' : '#424242'
        }`,
        borderRadius: 2,
      }}
      collapsible='icon'
      header={
        <Row gutter={16} style={{ width: '100%' }} align={'middle'}>
          <Col flex='3'>
            <SelectController
              label='Contexto'
              id={`configKeyContext-${name}-${index}`}
              name={`${name}.${index}.configKeyContext`}
              placeholder='Selecionar...'
              control={control}
              options={contextList.map(context => ({
                label: context.name,
                value: context.name,
              }))}
              loading={isLoadingContextList}
              required
            />
          </Col>
          <Col flex='1'>
            <SelectController
              label='Tipo'
              id={`configType-${name}-${index}`}
              placeholder='Selecionar...'
              name={`${name}.${index}.configType`}
              control={control}
              options={[
                { label: 'String', value: SettingsConfigType.String },
                { label: 'Número', value: SettingsConfigType.Number },
                { label: 'Booleano', value: SettingsConfigType.Boolean },
              ]}
              onSelect={() => {
                setValue(`${name}.${index}.configValue`, '');
              }}
              required
            />
          </Col>
          <Col flex='1'>
            <SelectController
              label='Visibilidade'
              id={`public-${name}-${index}`}
              placeholder='Selecionar...'
              name={`${name}.${index}.public`}
              control={control}
              options={[
                { label: 'Público', value: 'true' },
                { label: 'Privado', value: 'false' },
              ]}
              required
            />
          </Col>
          <Col flex='1'>
            <SelectController
              label='Criptografia'
              id={`encrypted-${name}-${index}`}
              placeholder='Selecionar...'
              name={`${name}.${index}.encrypted`}
              control={control}
              options={[
                { label: 'Sim', value: 'true' },
                { label: 'Não', value: 'false' },
              ]}
              onSelect={(value: string) => {
                if (value === 'true') {
                  setValue(
                    `${name}.${index}.configType`,
                    SettingsConfigType.String
                  );
                }
              }}
              required
            />
          </Col>
          <Col flex='0'>
            <Button
              type='text'
              style={{
                minWidth: 'auto',
                padding: '1px 6px',
              }}
              onClick={() => {
                onDelete(index, fields[index].id);
              }}
            >
              <DeleteOutlined
                style={{
                  fontSize: '16px',
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Col>
        </Row>
      }
      key={field._id}
    >
      <SettingsBody
        control={control}
        key={Date.now()}
        index={index}
        name={name}
      />
    </Collapse.Panel>
  ));
};
